import React from "react";

import { useMessageSource } from "react-message-source";
import { ApplicationFlows } from "../../../route/application/authenticated/application-flow/types";
import SameAsCardholderRadio from "../sameAsCardholderRadio";
import { SetNameAndSignatureType, SignatoryModel } from "../types";
import OtherThanCardholder from "./otherThanCardholder";
import SameAsCardholder from "./sameAsCardholder";
import { SignatoryType, SignatureType } from "../../../api/cybwell/types";

export default function PreloadedSignatories({
  values,
  persons,
  setNameAndSignatureType,
  flowType,
}: {
  values: SignatoryModel;
  persons: SignatoryType[];
  setNameAndSignatureType: SetNameAndSignatureType;
  flowType: ApplicationFlows;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  const needsSingleSignatory = (person: SignatoryType) => {
    return person && person.signatureType === SignatureType.Single;
  };

  const needsSecondSignatory = (person: SignatoryType) => {
    return person && person.signatureType === SignatureType.Double;
  };

  const oneSignaturePersons: SignatoryType[] =
    persons.filter(needsSingleSignatory);
  const twoSignaturePersons: SignatoryType[] =
    persons.filter(needsSecondSignatory);

  const singleSignatoriesDelimiter: SignatoryType = {
    id: "-1",
    firstName: getMessage("Signing.single-signatory-delimiter"),
    lastName: "",
    disabled: true,
  };
  const doubleSignatoriesDelimiter: SignatoryType = {
    id: "-2",
    firstName: getMessage("Signing.two-signatories-delimiter"),
    lastName: "",
    disabled: true,
  };

  const singleWithDelimiter =
    oneSignaturePersons && oneSignaturePersons.length > 0
      ? [singleSignatoriesDelimiter, ...oneSignaturePersons]
      : [];
  const doubleWithDelimiter =
    twoSignaturePersons && twoSignaturePersons.length > 0
      ? [doubleSignatoriesDelimiter, ...twoSignaturePersons]
      : [];

  const signatoriesFirstList = [...singleWithDelimiter, ...doubleWithDelimiter];

  const signatoriesSecondList =
    values.otherSignatories.length === 2
      ? [...oneSignaturePersons, ...twoSignaturePersons].filter(
          (p) => p.id !== values.otherSignatories[0].cybwellId,
        )
      : null;

  return (
    <>
      <SameAsCardholderRadio
        isSameAsCardholder={values.isSameAsCardholder}
        flowType={flowType}
        {...values.cardholderSignatories[0]}
      />
      {values.isSameAsCardholder === "yes" ? (
        <SameAsCardholder
          signatories={values.cardholderSignatories}
          setNameAndSignatureType={setNameAndSignatureType}
          prefilledPersons={[...oneSignaturePersons, ...twoSignaturePersons]}
        />
      ) : (
        <OtherThanCardholder
          setNameAndSignatureType={setNameAndSignatureType}
          firstList={signatoriesFirstList}
          signatories={values.otherSignatories}
          secondList={signatoriesSecondList}
        />
      )}
    </>
  );
}
